import React, { useState } from 'react';
import { CorretagemModal } from './CorretagemModal';
import './SearchHeader.css';

interface SearchHeaderProps {
  onSearch: (filters: any) => void;
  onBackToHome?: () => void;
  initialLocation?: string;
  onToggleFilters?: () => void;
  showFilters?: boolean;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({ onSearch, onBackToHome, initialLocation, onToggleFilters, showFilters }) => {
  const [searchLocation, setSearchLocation] = useState(initialLocation || '');
  const [isCorretagemModalOpen, setIsCorretagemModalOpen] = useState(false);

  React.useEffect(() => {
    if (initialLocation !== undefined) {
      setSearchLocation(initialLocation || '');
    }
  }, [initialLocation]);

  const handleLocationChange = (location: string) => {
    setSearchLocation(location);
  };

  const handleSearch = () => {
    onSearch({ location: searchLocation });
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="search-header">
      <div className="search-container">
        <div className="main-search-bar">
          <div className="location-input">
            <span className="location-icon">
              
            </span>
            <input
              type="text"
              value={searchLocation}
              onChange={(e) => handleLocationChange(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Centro, Praia dos Amores, Barra Sul..."
              className="location-field"
            />
            <button 
              className="search-btn"
              onClick={handleSearch}
              title="Buscar imóveis"
            >
              
            </button>
          </div>

          <button 
            className="search-action-btn"
            onClick={handleSearch}
            title="Buscar imóveis"
          >
            <span>Buscar</span>
          </button>

          {onToggleFilters && (
            <button 
              className="toggle-filters-btn"
              onClick={onToggleFilters}
              title={showFilters ? "Recolher filtros" : "Mais filtros"}
            >
              <span className="toggle-icon">{showFilters ? '▲' : '▼'}</span>
              <span>Mais Filtros</span>
            </button>
          )}

          <button 
            className="not-found-btn"
            onClick={() => setIsCorretagemModalOpen(true)}
            title="Não encontrou o que procura?"
          >
            <span>Não encontrou o que procura?</span>
          </button>
        </div>
      </div>

      <CorretagemModal 
        isOpen={isCorretagemModalOpen}
        onClose={() => setIsCorretagemModalOpen(false)}
      />
    </div>
  );
};